import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

function Terms() {
  return (
    <div className="legal-page">
      <div className="legal-page__container">
        <h1>利用規約</h1>
        <p className="legal-page__updated">最終更新日: 2025年6月30日</p>

        <section>
          <h2>1. はじめに</h2>
          <p>本サービス（以下「本サービス」）をご利用いただきありがとうございます。本サービスを利用することにより、あなたはこの利用規約（以下「本規約」）に同意したものとみなされます。本規約をよくお読みください。</p>
        </section>

        <section>
          <h2>2. サービスの利用</h2>
          <p>本サービスを利用するには、ユーザーは18歳以上である必要があります。また、本サービスの利用にあたり、ユーザーは以下のことを行わないことに同意します：</p>
          <ul>
            <li>法律に違反する行為、または違法行為を促進する行為</li>
            <li>他のユーザーに対する嫌がらせ、脅迫、いじめ</li>
            <li>虚偽、不正確、または誤解を招く情報の提供</li>
            <li>不適切なコンテンツの投稿（暴力、差別的内容など）</li>
            <li>本サービスのセキュリティを侵害する行為</li>
          </ul>
        </section>

        <section>
          <h2>3. ユーザーアカウント</h2>
          <p>ユーザーは自分のアカウントの安全を確保する責任があります。パスワードを他者と共有したり、他者のアカウントを使用したりしないでください。アカウントのセキュリティ侵害に気づいた場合は、直ちに運営者に連絡してください。</p>
        </section>

        <section>
          <h2>4. コンテンツ</h2>
          <p>ユーザーが本サービス上で投稿、アップロード、共有するコンテンツはユーザー自身が所有権を持ちます。ただし、ユーザーは当社に対して、そのコンテンツを使用、複製、修正、配布する権利を与えるものとします。</p>
        </section>

        <section>
          <h2>5. プライバシー</h2>
          <p>本サービスの利用によって収集される個人情報は、当社の<Link to="/privacy">プライバシーポリシー</Link>に基づいて取り扱われます。</p>
        </section>

        <section>
          <h2>6. 知的財産</h2>
          <p>本サービスおよびそのコンテンツ（テキスト、グラフィック、ロゴ、アイコンなど）は当社またはそのライセンサーが所有し、著作権法およびその他の知的財産法によって保護されています。</p>
        </section>

        <section>
          <h2>7. 免責事項</h2>
          <p>本サービスは「現状のまま」提供され、明示または黙示を問わず、いかなる保証もいたしません。当社は、本サービスの中断、エラー、セキュリティ上の脅威に対して責任を負いません。</p>
        </section>

        <section>
          <h2>8. 規約の変更</h2>
          <p>当社は、必要に応じて本規約を変更することがあります。変更があった場合は、本サービス上で通知します。変更後も本サービスを継続して利用することにより、あなたは変更後の規約に同意したものとみなされます。</p>
        </section>

        <section>
          <h2>9. 連絡先</h2>
          <p>本規約に関するご質問やお問い合わせは、<a href="mailto:support@deli-ns.com">support@deli-ns.com</a>までご連絡ください。</p>
        </section>

        <div className="legal-page__footer">
          <Link to="/" className="legal-page__back">ホームに戻る</Link>
        </div>
      </div>
    </div>
  );
}

export default Terms; 